import script from "./CustomDashboardOkrModuleContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardOkrModuleContent.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardOkrModuleContent.vue?vue&type=style&index=0&id=41e5bf1b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e5bf1b"]])

export default __exports__